const DataGrid = theme => {
  return {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: 0,
          color: theme.palette.text.primary,
          '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none'
          }
        },
        toolbarContainer: {
          paddingRight: `${theme.spacing(5)}`,
          paddingLeft: `${theme.spacing(3.25)}`
        },
        columnHeaders: {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          maxHeight: '54px',
          minHeight: '54px',
          lineHeight: '24px',
          backgroundColor: theme.palette.customColors.tableHeaderBg
        },
        columnHeader: {
          height: '54px',
          '&:not(.MuiDataGrid-columnHeaderCheckbox)': {
            padding: theme.spacing(4),
            '&:first-of-type': {
              paddingLeft: theme.spacing(5)
            }
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(5)
          }
        },
        columnHeaderCheckbox: {
          maxWidth: '58px',
          minWidth: '58px'
        },
        columnHeaderTitleContainer: {
          padding: 0
        },
        columnHeaderTitle: {
          fontWeight: 600,
          fontSize: '0.75rem',
          letterSpacing: '0.17px',
          textTransform: 'uppercase'
        },
        columnSeparator: {
          display: 'none'
        },
        virtualScroller: {
          marginTop: '54px'
        },
        virtualScrollerRenderZone: {
          '& .MuiDataGrid-row': {
            maxHeight: '50px',
            minHeight: '50px'
          }
        },
        row: {
          '&:hover':{
            backgroundColor: theme.palette.grey[100]
          },
          '&:last-child': {
            '& .MuiDataGrid-cell': {
              borderBottom: `1px solid ${theme.palette.grey[300]}`
            }
          }
        },
        cell: {
          maxHeight: '50px',
          minHeight: '50px',
          lineHeight: '20px',
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          '&:not(.MuiDataGrid-cellCheckbox)': {
            padding: theme.spacing(4),
            '&:first-of-type': {
              paddingLeft: theme.spacing(5)
            }
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(5)
          },
          '&:focus, &:focus-within': {
            outline: 'none'
          }
        },
        cellCheckbox: {
          maxWidth: '58px',
          minWidth: '58px'
        },
        editInputCell: {
          padding: 0,
          color: theme.palette.text.primary,
          '& .MuiInputBase-input': {
            padding: 0
          }
        },
        footerContainer: {
          minHeight: '50px',
          borderTop: `1px solid ${theme.palette.grey[300]}`,
          '& .MuiTablePagination-toolbar': {
            minHeight: '50px'
          },
          '& .MuiTablePagination-select': {
            color: theme.palette.text.primary
          }
        }
      },
      defaultProps: {
        rowHeight: 50,
        headerHeight: 54
      }
    }
  }
}

export default DataGrid
